module.exports = __webpack_public_path__ + "img/big_files@2x.96961d8e.png";